import { StandardRecordIcon } from '~/components/Icon/StandardRecordsIcon';
import { CompetitionIcon } from '~/components/Icon/CompetitionIcon';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { MenuInline } from '~/components/MenuInline/MenuInline';
import { DistrictIcon } from '~/components/Icon/DistrictIcon';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { UsersIcon } from '~/components/Icon/UsersIcon';
import { TeamsIcon } from '~/components/Icon/TeamsIcon';
import { ClubIcon } from '~/components/Icon/ClubIcon';
import { Outlet } from 'react-router';

export const Layout = withPrivateRoute(() => {
  const { can } = useAuthentication();

  return (
    <PageLayout title="Admin">
      <MenuInline>
        <MenuInline.Item label="Mina föreningar" to="/admin/my-clubs" icon={ClubIcon} />
        <MenuInline.Item label="Mina tävlingar" to="/admin/my-competitions" icon={CompetitionIcon} />
        <MenuInline.Item label="Mina distrikt" to="/admin/my-districts" icon={DistrictIcon} />
        <MenuInline.Item label="Mina lag" to="/admin/my-teams" icon={TeamsIcon} />
        {can('manage-users') && <MenuInline.Item label="Användare" to="/admin/users" icon={UsersIcon} />}
        {can('manage-standard-records') && (
          <MenuInline.Item label="Standardrekord" to="/admin/standard-records" icon={StandardRecordIcon} />
        )}
      </MenuInline>

      <Outlet />
    </PageLayout>
  );
});
